import React from 'react';
import Config from 'react-native-config';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { dfdDefaultTheme, MuiBox, MuiButton, MuiTypography } from 'theme/material-ui';

import Svg from 'components/UI/Svg/Svg';

import { moreInfo as moreInfoConst } from 'modules/constants/booking';
import { FontSize, FontWeight, IconSize } from 'modules/styles/variables';

import { specialtyListItem } from '../../components/sharedComponents';
import { CloseButton, SpecialtyUl, StyledMuiDialog } from '../../components/styled';

import * as bookingTypes from 'store/booking/types';
import * as bookingSelectors from 'store/booking/selectors';
import { useSelector } from 'react-redux';

export interface Props {
  fullScreen?: boolean;
  handleClose: Function;
  isOpen: boolean;
  secondScreen?: boolean;
}

export function SpecialtyOrMyDoctorSelectMoreInfoDialog({ handleClose, isOpen }: Props) {
  const fullScreen = useMediaQuery(dfdDefaultTheme.breakpoints.down('sm'));
  const specialties = useSelector(bookingSelectors.getSpecialtiesSortedByName);

  const filterSpecialties = (
    moreInfoData: bookingTypes.SpecialtyMoreInfo,
    obgyn: boolean,
    pediatrics: boolean
  ) => {
    const title = `${moreInfoData.title} `.replace(/\s/g, ' ');
    const description = `${moreInfoData.description}`.replace(/\s/g, ' ');
    if (title === moreInfoConst.DIALOG_CONTENT.SPECIALTY_OR_MY_DOCTOR.OBGYN_TITLE && !obgyn) {
      return null;
    }
    if (
      title === moreInfoConst.DIALOG_CONTENT.SPECIALTY_OR_MY_DOCTOR.PEDIATRICS_TITLE &&
      !pediatrics
    ) {
      return null;
    }
    return specialtyListItem(title, description);
  };

  const filterInActiveSpecialties = (title: string, description: string) => {
    return specialtyListItem(title, description);
  };

  return (
    <StyledMuiDialog
      fullScreen={fullScreen}
      maxWidth="md"
      open={isOpen}
      onClose={() => handleClose()}
    >
      <MuiBox p={3} py={2} data-testid="more-info-dialog-container">
        <CloseButton onClick={handleClose} data-testid="more-info-dialog-close-icon">
          <Svg name="CloseIcon" size={IconSize.medium} />
        </CloseButton>
        <MuiBox display="flex" justifyContent="start" py={2}>
          <MuiTypography align="center" fontSize={FontSize.mediumHeading}>
            Don't see what you're looking for?
          </MuiTypography>
        </MuiBox>
        <MuiBox pb={2}>
          <MuiTypography>
            {moreInfoConst.DIALOG_CONTENT.SPECIALTY_OR_MY_DOCTOR.SECTION_ONE_TEXT}
          </MuiTypography>
        </MuiBox>
        <MuiBox pb={1}>
          <MuiTypography component="span" fontWeight={FontWeight.bold}>
            {moreInfoConst.DIALOG_CONTENT.SPECIALTY_OR_MY_DOCTOR.SPECIALTIES_TITLE}
          </MuiTypography>
          <MuiTypography component="span">
            {moreInfoConst.DIALOG_CONTENT.SPECIALTY_OR_MY_DOCTOR.SPECIALTIES_DESCRIPTION}
          </MuiTypography>
        </MuiBox>
        <MuiBox pb={1}>
          <MuiTypography component="span">
            {moreInfoConst.DIALOG_CONTENT.SPECIALTY_OR_MY_DOCTOR.ACTIVE_SPECIALTY_TEXT}
          </MuiTypography>
        </MuiBox>
        <SpecialtyUl>
          {specialties.map(({ moreInfo }) =>
            filterSpecialties(moreInfo, Config.OBGYN === 'enabled', Config.PEDIATRICS === 'enabled')
          )}
        </SpecialtyUl>
        <MuiBox pb={1}>
          <MuiTypography component="span">
            {moreInfoConst.DIALOG_CONTENT.SPECIALTY_OR_MY_DOCTOR.INACTIVE_SPECIALTY_TEXT}
          </MuiTypography>
        </MuiBox>
        <SpecialtyUl>
          {moreInfoConst.DIALOG_CONTENT.SPECIALTY_OR_MY_DOCTOR.SPECIALTIES_INACTIVE.map(
            ({ title, description }) => filterInActiveSpecialties(title, description)
          )}
        </SpecialtyUl>
        <MuiBox py={2}>
          <MuiTypography>
            {moreInfoConst.DIALOG_CONTENT.SPECIALTY_OR_MY_DOCTOR.SECTION_TWO_TEXT}
          </MuiTypography>
        </MuiBox>
        <MuiBox pb={2}>
          <MuiTypography>
            {moreInfoConst.DIALOG_CONTENT.SPECIALTY_OR_MY_DOCTOR.SECTION_THREE_TEXT}
          </MuiTypography>
        </MuiBox>
        <MuiBox display="flex" pt={3} justifyContent="center">
          <MuiButton variant="contained" color="primary" fullWidth onClick={() => handleClose()}>
            Close
          </MuiButton>
        </MuiBox>
      </MuiBox>
    </StyledMuiDialog>
  );
}

export default SpecialtyOrMyDoctorSelectMoreInfoDialog;
